export default "__VITE_ASSET__S5Aw6s9m__"